import React, { Component } from 'react';
import moment from 'moment';
import { toString, keyBy, forEach, replace, find, get } from 'lodash';
import { Row, Select, Radio } from 'antd';
import validator from 'validator';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import helpers from 'utils/helpers';
import {
  FormTitle,
  StyledCol,
  StyledFormItem,
  StyledSelect,
  StyledDatePicker,
  StyledRadioGroup
} from 'components/Styled';
import Hint from 'components/common/Hint';
import countries from 'data/countries';

const { Option } = Select;
const startTime = moment('10:00', 'HH:mm');
const pickupTime = [];

for (let i = 0; i < 4; i++) {
  pickupTime.push({
    from: startTime.format('HH:mm'),
    to: moment(startTime).add(2, 'h').format('HH:mm')
  });
  startTime.add(2, 'h');
}

class DateForm extends Component {
  state = {
    pickupDate: '',
    pickupTime: '',
    pickupDateHintVisible: false,
    selfPickup: false
  };

  gtmEvents = {
    pickupDate: `Selected ${this.gtmSubject} Date`,
    pickupTime: `Selected ${this.gtmSubject} Time`
  };

  disabledDate = date => {
    return this.props.availableData.every(
      x => !(x.date === date.format('YYYY-MM-DD'))
    );
  };

  validateType = {
    pickupDate: this.props.showPickup ? 'required' : null,
    pickupTime: this.props.showPickup ? 'required' : null
  };

  validate = () => {
    const fields = ['pickupDate', 'pickupTime'];

    const states = {};
    forEach(fields, field => {
      states[field + 'Changed'] = true;
      states[field + 'Status'] = this.validateError(field) ? 'error' : '';
      states[field + 'Help'] = this.validateError(field);
    });

    this.setState(states);

    let success = true;

    for (var i = 0; i < fields.length; i++) {
      if (this.validateError(fields[i])) {
        success = false;
      }
    }

    if (this.addressCard.current && !this.addressCard.current.validate()) {
      success = false;
    }

    return success;
  };

  getFormData = () => {
    const { selfPickup, pickupDate, pickupTime } = this.state;

    if (selfPickup) {
      return {
        selfPickup,
        pickupDate: moment().format('YYYY-MM-DD'),
        minPickupTime: moment().format('HH:mm'),
        maxPickupTime: moment().format('HH:mm')
      };
    }
    return {
      selfPickup,
      pickupDate: moment(pickupDate).format('YYYY-MM-DD'),
      minPickupTime: get(this.state.pickupTimes, `[${pickupTime}].from`),
      maxPickupTime: get(this.state.pickupTimes, `[${pickupTime}].to`)
    };
  };

  autoSave = () => {
    const key = this.props.showPickup ? 'fromAddress' : 'toAddress';
    const data = this.getFormData();
    delete data.pickupDate;
    delete data.minPickupTime;
    delete data.maxPickupTime;
    data.country = this.props.country;

    this.props.autoSave(key, data);
  };

  handlePickerOpen = open => {
    if (open) {
      setTimeout(() => {
        const input = document.querySelector('.ant-picker-input input');
        input.readOnly = true; // to prevent keyboard popup
      }, 0);
    }
  };

  handleInputChange = (value, name) => {
    this.setState(
      {
        [name]: value,
        [name + 'Changed']: true
      },
      () => {
        this.setState({
          [name + 'Status']: this.validateError(name) ? 'error' : '',
          [name + 'Help']: this.validateError(name)
        });
      }
    );
    if (name === 'pickupDate') {
      const selectedDate = moment(value).format('YYYY-MM-DD');
      const pickupTimes =
        keyBy(this.props.availableData, 'date')[selectedDate]['time'] || [];
      this.setState({
        pickupTimes
      });
    }
  };

  validateError = name => {
    let patterns;
    const value = toString(this.state[name]);

    if (value.length > 35) {
      return '請輸入少於35個字符';
    }

    switch (this.validateType[name]) {
      case 'optional':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return null;
        }

        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'required':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'phone':
        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!validator.isMobilePhone(replace(value, /\s/g, ''))) {
          return `pickup.err_msg.${name}.format`;
        }

        return null;
      case 'chars':
        patterns = /^[A-Z\s\-.']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'zip': // TODO: match country
        patterns = /^[0-9A-Z\s\-']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      default:
        return null;
    }
  };

  handleInputBlur = name => {
    this.setState(
      {
        [name + 'Changed']: true
      },
      () => {
        this.setState({
          [name + 'Status']: this.validateError(name) ? 'error' : '',
          [name + 'Help']: this.validateError(name)
        });
      }
    );
  };

  onRadioChange = e => {
    const val = e.target.value;
    this.setState({ selfPickup: val });
  };

  renderDropOffOptions = () => {
    const carrier = helpers.getCarrierText(this.props.carrier);

    const pickupOptions = [
      {
        label: this.props.t('pickup.options.pickup'),
        value: false,
        url: null,
        desc: null
      },
      {
        label: this.props.t('pickup.options.dropoff', { carrier }),
        value: true,
        url:
          'https://spaceship.crisp.help/zh-hk/article/5aac5l2v6acq57se5ae5lu2-fa6cn0/',
        desc: this.props.t('pickup.dropoff_station', { carrier })
      }
    ];

    // Disable all drop-off
    // https://www.notion.so/spaceshiphk/Open-Box-Check-c85a956033654ec3987dab6d53a64668
    const acceptDropOff = [];

    if (
      acceptDropOff.includes(this.props.carrier) &&
      this.props.country === 'HK'
    ) {
      return (
        <StyledRadioGroup
          value={this.state.selfPickup}
          onChange={this.onRadioChange}
          disabled={this.props.loading}>
          {pickupOptions.map((option, i) => (
            <div style={{ marginBottom: 20 }}>
              <Radio key={`options_${i}`} value={option.value}>
                <div>
                  <div style={{ color: '#2C2C2E', fontSize: 14 }}>
                    {option.label}
                  </div>
                  {option.desc && (
                    <div
                      className="buttonTheme-color"
                      style={{
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: '#9900A5',
                        marginTop: 5
                      }}>
                      {
                        <a
                          className="buttonTheme-color"
                          target="_blank"
                          href={option.url || 'javascript:void(0)'}
                          style={{
                            cursor: option.url ? 'pointer' : 'auto'
                          }}>
                          {option.desc}{' '}
                          {option.url && (
                            <FontAwesomeIcon icon="external-link-alt" />
                          )}
                        </a>
                      }
                    </div>
                  )}
                </div>
              </Radio>
            </div>
          ))}
        </StyledRadioGroup>
      );
    }
    return null;
  };

  render() {
    return (
      <div ref={this.container}>
        <div>
          <Row
            type="flex"
            gutter={14}
            style={{
              paddingTop: '5px'
            }}>
            <StyledCol>
              <h3>{this.props.t('pickup.form.title')}</h3>
            </StyledCol>
          </Row>
          <div
            style={{
              height: '1px',
              marginTop: 5,
              borderTop: '1px solid #f5f5f5'
            }}></div>
          <Row type="flex" gutter={14} style={{ paddingTop: '15px' }}>
            <StyledCol>{this.renderDropOffOptions()}</StyledCol>
          </Row>
          {!this.state.selfPickup && (
            <Row type="flex" gutter={14} style={{ paddingTop: '15px' }}>
              <StyledCol>
                <FormTitle>
                  {get(
                    find(this.props.countries, ['alpha-2', this.props.country]),
                    `name.${this.props.t('key')}`
                  ) + this.props.t('pickup.form.pickup_date')}
                  <Hint
                    msg={this.props.t('pickup.hints.fedex_hint')}
                    visible={
                      this.props.showPickup &&
                      this.props.carrier === 'fedex' &&
                      this.props.country === 'HK'
                    }
                  />
                </FormTitle>
                <StyledFormItem
                  validateStatus={
                    (this.state['pickupDateChanged'] &&
                      this.state['pickupDateStatus']) ||
                    ''
                  }
                  help={
                    this.state['pickupDateChanged'] &&
                    this.props.t(this.state['pickupDateHelp'])
                  }>
                  <StyledDatePicker // TODO: handle public holiday
                    allowClear={false}
                    size="large"
                    disabled={this.props.loading}
                    onOpenChange={this.handlePickerOpen}
                    placeholder={this.props.t('common.select')}
                    value={this.state['pickupDate'] || null}
                    onChange={value => {
                      this.handleInputChange(value, 'pickupDate');
                    }}
                    disabledDate={this.disabledDate}
                  />
                </StyledFormItem>
              </StyledCol>
              <StyledCol>
                <FormTitle>
                  {get(
                    find(this.props.countries, ['alpha-2', this.props.country]),
                    `name.${this.props.t('key')}`
                  ) + this.props.t('pickup.form.pickup_time')}
                </FormTitle>
                <StyledFormItem
                  disabled={this.props.loading}
                  validateStatus={
                    (this.state['pickupTimeChanged'] &&
                      this.state['pickupTimeStatus']) ||
                    ''
                  }
                  help={
                    this.state['pickupTimeChanged'] &&
                    this.props.t(this.state['pickupTimeHelp'])
                  }>
                  <StyledSelect
                    size="large"
                    disabled={this.props.loading}
                    placeholder={this.props.t('common.select')}
                    value={this.state['pickupTime']}
                    onChange={value => {
                      this.handleInputChange(value, 'pickupTime');
                    }}
                    onBlur={() => {
                      this.handleInputBlur('pickupTime');
                    }}>
                    {this.state.pickupTimes
                      ? this.state.pickupTimes.map((time, i) => (
                          <Option key={i} value={i}>
                            {time.from} - {time.to}{' '}
                            {time.extra ? `(${time.extra})` : ''}
                          </Option>
                        ))
                      : ''}
                  </StyledSelect>
                </StyledFormItem>
              </StyledCol>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    getAutoSaveFinished: !!state.shipments.getAutoSaveFinished,
    pickupTimes: state.pickupTimes || [],
    countries: state.shipments.countries || countries
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  DateForm
);
